import Decimal from 'decimal.js';
import { IPayRange } from 'store/entities/configuration/configurationModel';

export const isPayRateInPayRange = (payRate: number | string, payRange: IPayRange): boolean => {
    const payRateValue = new Decimal(payRate);
    const min = new Decimal(payRange.min_value);
    const max = new Decimal(payRange.max_value);
    return payRateValue >= min && payRateValue <= max;
};
